<template>
	<el-dialog title="维修验收单预览" :visible.sync="dialogVisible" width="90%" :before-close="handleClose"
		class="preview-acceptance-dialog">
		<div v-loading="loading" class="preview-content">
			<div v-if="acceptanceDetail" class="forms-container">
				<!-- 验收单表格 -->
				<div id="acceptance-form" class="acceptance-form">
					<!-- 表格 -->
					<table class="acceptance-table" border="1" cellspacing="0" cellpadding="0">
						<!-- 标题行 -->
						<tr>
							<td colspan="4" class="title-cell">
								资中县兴资物业管理有限责任公司维修验收单
							</td>
						</tr>

						<!-- 第一行：验收名称、验收时间 -->
						<tr>
							<td class="label-cell">验收名称</td>
							<td class="value-cell">{{ getAcceptanceName() }}</td>
							<td class="label-cell">验收时间</td>
							<td class="value-cell">{{ getCurrentDate() }}</td>
						</tr>

						<!-- 第二行：安装单位、验收地点 -->
						<tr>
							<td class="label-cell">安装单位</td>
							<td class="value-cell">{{ getSupplierName() }}</td>
							<td class="label-cell">验收地点</td>
							<td class="value-cell">{{ getLocationText() }}</td>
						</tr>

						<!-- 第三行：验收组织部门 -->
						<tr>
							<td class="label-cell">验收组织部门</td>
							<td colspan="3" class="value-cell">项目物业管理处</td>
						</tr>

						<!-- 第四行：验收内容 -->
						<tr>
							<td class="label-cell">验收内容</td>
							<td colspan="3" class="value-cell content-text">
								{{ acceptanceDetail.problemDesc || acceptanceDetail.content || '-' }}
							</td>
						</tr>

						<!-- 第五行：验收结果 -->
						<tr>
							<td class="label-cell">验收结果</td>
							<td colspan="3" class="value-cell">已正常使用</td>
						</tr>

						<!-- 第六行：结算金额 -->
						<tr>
							<td class="label-cell">结算金额</td>
							<td colspan="3" class="value-cell">{{ getSettlementAmount() }}</td>
						</tr>

						<!-- 第七行：施工单位负责人签字 -->
						<tr>
							<td class="label-cell">施工单位负责人签字</td>
							<td colspan="3" class="signature-cell"></td>
						</tr>

						<!-- 第八行：验收人员签字 -->
						<tr>
							<td class="label-cell">验收人员签字</td>
							<td colspan="3" class="signature-cell"></td>
						</tr>

						<!-- 第九行：施工维修及验收图片 -->
						<tr>
							<td colspan="4" class="section-title-cell">施工维修及验收图片</td>
						</tr>

						<!-- 第十行：图片展示区 -->
						<tr>
							<td colspan="4" class="images-section-cell">
								<div v-if="getAllImagesList().length > 0" class="image-grid-acceptance">
									<div v-for="(img, index) in getAllImagesList()" :key="'all-' + index"
										class="image-item-acceptance">
										<img :src="img" class="acceptance-image" @error="handleImageError" />
									</div>
								</div>
							</td>
						</tr>

						<!-- 第十二行：物业管理处 -->
						<tr>
							<td colspan="4" class="footer-cell">{{ getCommunityName() }}</td>
						</tr>

						<!-- 第十三行：日期 -->
						<tr>
							<td colspan="4" class="footer-cell">{{ getCurrentDate() }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>

		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">关闭</el-button>
			<el-button type="primary" @click="handleExportAcceptancePDF">导出验收单PDF</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import jsPDF from 'jspdf'
	import html2canvas from 'html2canvas'

	export default {
		name: 'PreviewAcceptanceForm',
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			acceptanceDetail: {
				type: Object,
				default: null
			}
		},
		data() {
			return {
				loading: false,
				preloadedImages: new Map()
			}
		},
		computed: {
			dialogVisible: {
				get() {
					return this.visible
				},
				set(val) {
					if (!val) {
						this.$emit('close')
					}
				}
			}
		},
		watch: {
			visible(val) {
				if (val) {
					document.body.style.overflow = 'hidden'
				} else {
					document.body.style.overflow = ''
				}
			}
		},
		methods: {
			handleClose() {
				this.$emit('close')
			},

			// 鑾峰彇验收名称 - 鏍规嵁orderType鍒ゆ柇
			getAcceptanceName() {
				if (!this.acceptanceDetail) return 'XX维修'

				const orderType = this.acceptanceDetail.orderType
				if (orderType === 0 || orderType === '0') {
					return '室内维修'
				} else if (orderType === 1 || orderType === '1') {
					return '公区维修'
				}
				return 'XX维修'
			},

			// 获取当前日期 - 格式：2026年X月X日
			getCurrentDate() {
				// 优先使用acceptTime字段
				if (this.acceptanceDetail && this.acceptanceDetail.acceptTime) {
					return this.formatDateToChineseStyle(this.acceptanceDetail.acceptTime)
				}

				// 如果没有acceptTime，使用当前时间
				const now = new Date()
				const year = now.getFullYear()
				const month = now.getMonth() + 1
				const day = now.getDate()
				return `${year}年${month}月${day}日`
			},

			// 格式化日期为中文样式：2026年X月X日
			formatDateToChineseStyle(dateString) {
				if (!dateString) return ''

				try {
					const date = new Date(dateString)
					const year = date.getFullYear()
					const month = date.getMonth() + 1
					const day = date.getDate()
					return `${year}年${month}月${day}日`
				} catch (error) {
					console.log('日期格式化失败', error)
					return ''
				}
			},

			// 获取供应商名称
			getSupplierName() {
				if (!this.acceptanceDetail) return '**公司'

				// 尝试从supplierInfo解析
				if (this.acceptanceDetail.supplierInfo) {
					try {
						let supplierInfo = this.acceptanceDetail.supplierInfo
						if (typeof supplierInfo === 'string') {
							supplierInfo = JSON.parse(supplierInfo)
						}

						if (Array.isArray(supplierInfo) && supplierInfo.length > 0) {
							const names = supplierInfo.map(item => item.name || '').filter(name => name)
							if (names.length > 0) {
								return names.join('，')
							}
						} else if (supplierInfo && supplierInfo.name) {
							return supplierInfo.name
						}
					} catch (e) {
						console.warn('解析供应商信息失败', e)
					}
				}

				// 如果没有供应商信息，使用小区名称 + 公司
				const communityName = this.acceptanceDetail.communityName ||
					this.acceptanceDetail.community ||
					this.acceptanceDetail.projectName ||
					'**'

				return `${communityName}公司`
			},

			// 获取维修地点
			getLocationText() {
				if (!this.acceptanceDetail) return '**'

				// 如果是公区报修(orderType === 1)，使用 addressDetail
				if (this.acceptanceDetail.orderType === 1 || this.acceptanceDetail.orderType === '1') {
					return this.acceptanceDetail.addressDetail || '**'
				}
				// 如果是室内报修(orderType === 0)，使用 roomName
				else if (this.acceptanceDetail.orderType === 0 || this.acceptanceDetail.orderType === '0') {
					return this.acceptanceDetail.roomName || '**'
				}

				// 默认情况
				return this.acceptanceDetail.addressDetail || this.acceptanceDetail.roomName || '**'
			},

			// 鑾峰彇结算金额
			getSettlementAmount() {
				if (!this.acceptanceDetail) return '**元'

				// 尝试从auditControl获取控价金额
				if (this.acceptanceDetail.auditControl) {
					try {
						let auditControl = this.acceptanceDetail.auditControl
						if (typeof auditControl === 'string') {
							auditControl = JSON.parse(auditControl)
						}

						if (auditControl && auditControl.controlNum) {
							return `${auditControl.controlNum}元`
						}
					} catch (e) {
						console.warn('解析审核控价信息失败:', e)
					}
				}

				// 尝试从其他字段获取金额
				if (this.acceptanceDetail.repairMaterialFee) {
					return `${this.acceptanceDetail.repairMaterialFee}元`
				}

				return '**元'
			},

			// 获取小区名称 + 物业管理处
			getCommunityName() {
				if (!this.acceptanceDetail) return '**物业管理处'

				// 尝试从多个可能的字段获取小区名称
				const communityName = this.acceptanceDetail.communityName ||
					this.acceptanceDetail.community ||
					this.acceptanceDetail.projectName ||
					'**'

				return `${communityName}物业管理处`
			},

			getImageList(imgsString) {
				if (!imgsString || typeof imgsString !== 'string') {
					return []
				}
				return imgsString.split(',').filter(url => url.trim() !== '')
			},


			// 获取维修过程图片
			getProcessImageList() {
				if (!this.acceptanceDetail || !this.acceptanceDetail.repairProcessImgs) return []

				try {
					const data = typeof this.acceptanceDetail.repairProcessImgs === 'string' ?
						JSON.parse(this.acceptanceDetail.repairProcessImgs) :
						this.acceptanceDetail.repairProcessImgs

					if (data && data.images) {
						if (typeof data.images === 'string') {
							return data.images.split(',').filter(img => img.trim())
						}
						if (Array.isArray(data.images)) {
							return data.images.filter(img => img && img.trim())
						}
					}

					return []
				} catch (err) {
					console.log('解析维修图片失败:', err)
					return []
				}
			},

			// 获取维修后图片
			getAfterImageList() {
				if (!this.acceptanceDetail || !this.acceptanceDetail.repairAfterImgs) return []

				try {
					let data
					if (typeof this.acceptanceDetail.repairAfterImgs === 'string') {
						data = JSON.parse(this.acceptanceDetail.repairAfterImgs)
					} else {
						data = this.acceptanceDetail.repairAfterImgs
					}

					if (data && data.images) {
						if (typeof data.images === 'string') {
							return data.images.split(',').filter(img => img.trim())
						}
						if (Array.isArray(data.images)) {
							return data.images.filter(img => img && img.trim())
						}
					}
					return []
				} catch (err) {
					console.log('解析验收图片失败:', err)
					return []
				}
			},

			// 合并所有图片（维修前、维修中、维修后）
			getAllImagesList() {
				const beforeImages = this.getImageList(this.acceptanceDetail && this.acceptanceDetail.problemImgs) || []
				const processImages = this.getProcessImageList() || []
				const afterImages = this.getAfterImageList() || []
				const allImages = [...beforeImages, ...processImages, ...afterImages]
				console.log('所有图片URL:', allImages)
				return allImages
			},

			handleImageError(e) {
				e.target.style.display = 'none'
			},

			// 导出验收单PDF
			async handleExportAcceptancePDF() {
				await this.exportPDF('acceptance-form', '维修验收单')
			},

			// 预加载图片到内存 - 使用fetch方式
			async preloadImages(imageUrls) {
				const promises = imageUrls.map(url => {
					return new Promise(async (resolve) => {
						if (this.preloadedImages.has(url)) {
							resolve(this.preloadedImages.get(url))
							return
						}
						try {
							const response = await fetch(url)
							const blob = await response.blob()
							const reader = new FileReader()
							reader.onloadend = () => {
								const dataUrl = reader.result
								this.preloadedImages.set(url, dataUrl)
								resolve(dataUrl)
							}
							reader.onerror = () => resolve(url)
							reader.readAsDataURL(blob)
						} catch (e) {
							console.log('fetch方式失败:', e)
							// fetch失败则尝试Image方式
							const img = new Image()
							img.crossOrigin = 'anonymous'
							img.onload = () => {
								const canvas = document.createElement('canvas')
								canvas.width = img.width
								canvas.height = img.height
								const ctx = canvas.getContext('2d')
								ctx.drawImage(img, 0, 0)
								try {
									const dataUrl = canvas.toDataURL('image/jpeg', 0.95)
									this.preloadedImages.set(url, dataUrl)
									resolve(dataUrl)
								} catch (e2) {
									resolve(url)
								}
							}
							img.onerror = () => resolve(url)
							img.src = url
						}
					})
				})
				await Promise.all(promises)
			},

			// 替换图片src为缓存的数据URL
			replaceImagesWithCache(element) {
				const images = element.querySelectorAll('img')
				images.forEach(img => {
					const cacheUrl = this.preloadedImages.get(img.src)
					if (cacheUrl && cacheUrl !== img.src) {
						img.src = cacheUrl
					}
				})
			},

			// 等待所有图片加载完成
			async waitForImages(element) {
				const images = element.querySelectorAll('img')
				console.log('等待图片数量:', images.length)

				if (images.length === 0) {
					return
				}

				const promises = Array.from(images).map((img, index) => {
					console.log('图片' + index + ':', img.src, 'complete:', img.complete, 'naturalHeight:', img
						.naturalHeight)
					if (img.complete && img.naturalHeight !== 0) {
						return Promise.resolve()
					}
					return new Promise((resolve) => {
						img.onload = () => {
							console.log('图片' + index + '加载完成')
							resolve()
						}
						img.onerror = () => {
							console.log('图片' + index + '加载失败')
							resolve()
						}
					})
				})
				await Promise.all(promises)
				console.log('所有图片等待完成')
			},

			async exportPDF(elementId, fileName) {
				if (!this.acceptanceDetail) {
					this.$message.warning('没有可导出的数据')
					return
				}

				try {
					await this.$confirm(`确定要导出${fileName}PDF吗？`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'info'
					})
				} catch {
					return
				}

				const loadingInstance = this.$loading({
					lock: true,
					text: '正在生成PDF，请稍等...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				})

				try {
					const element = document.getElementById(elementId)
					if (!element) {
						throw new Error('未找到表格元素')
					}

					// 收集所有图片URL
					const imageUrls = []
					const images = element.querySelectorAll('img')
					images.forEach(img => {
						if (img.src && !img.src.startsWith('data:')) {
							imageUrls.push(img.src)
						}
					})

					console.log('需要处理的图片URLs:', imageUrls)

					// 预加载所有图片
					if (imageUrls.length > 0) {
						await this.preloadImages(imageUrls)
						// 替换DOM中的图片src为缓存的数据URL
						this.replaceImagesWithCache(element)
					}

					// 等待图片加载完成
					await this.waitForImages(element)
					// 额外等待确保渲染完成
					await new Promise(resolve => setTimeout(resolve, 500))

					const canvas = await html2canvas(element, {
						scale: 2,
						useCORS: true,
						allowTaint: true,
						logging: false,
						backgroundColor: '#ffffff',
						imageTimeout: 0,
						foreignObjectRendering: false
					})

					console.log('Canvas尺寸:', canvas.width, canvas.height)

					const imgWidth = 210
					const imgHeight = (canvas.height * imgWidth) / canvas.width

					const pdf = new jsPDF({
						orientation: 'portrait',
						unit: 'mm',
						format: 'a4'
					})

					const imgData = canvas.toDataURL('image/jpeg', 1.0)
					pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight)

					const pdfFileName =
						`${this.acceptanceDetail.acceptanceNo || this.acceptanceDetail.acceptanceId || 'acceptance'}_${fileName}.pdf`

					pdf.save(pdfFileName)

					this.$message.success('PDF生成成功')
				} catch (error) {
					console.log('PDF generation error:', error)
					this.$message.error('PDF生成失败：' + error.message)
				} finally {
					loadingInstance.close()
				}
			},

			async handleExportPDF() {
				// 保留旧方法以兼容
				await this.handleExportAcceptancePDF()
			}
		}
	}
</script>

<style scoped>
	.preview-acceptance-dialog>>>.el-dialog {
		max-height: none;
		display: flex;
		flex-direction: column;
	}

	.preview-acceptance-dialog>>>.el-dialog__body {
		flex: 1;
		overflow: visible;
		padding: 20px;
		background-color: #f0f0f0;
	}

	.preview-content {
		display: flex;
		justify-content: center;
		overflow: visible;
	}

	.forms-container {
		display: flex;
		gap: 20px;
		flex-wrap: wrap;
		justify-content: center;
	}

	/* A4纸张尺寸：210mm x 297mm */
	.acceptance-form,
	.supervision-form {
		background: white;
		width: 210mm;
		min-height: 297mm;
		padding: 8mm;
		margin: 0 auto;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
		box-sizing: border-box;
	}

	.acceptance-table,
	.supervision-table {
		width: 100%;
		border-collapse: collapse;
		border: 1px solid #999;
		table-layout: fixed;
	}

	.acceptance-table td {
		border: 1px solid #999;
		padding: 10px 8px;
		font-size: 13px;
		vertical-align: middle;
		word-wrap: break-word;
		line-height: 1.5;
		color: #000;
	}

	/* 标题单元格 */
	.title-cell {
		text-align: center !important;
		font-size: 24px !important;
		font-weight: bold !important;
		padding: 15px 12px !important;
		line-height: 1.5 !important;
		color: #000 !important;
		background-color: #fff !important;
	}

	.label-cell {
		font-weight: normal;
		text-align: center;
		width: 25%;
		color: #000;
		background-color: #fff;
		padding: 10px 5px !important;
	}

	.value-cell {
		text-align: center;
		color: #000;
		padding: 10px 8px !important;
		line-height: 1.5;
		width: 25%;
	}

	/* 验收内容鏂囧瓧 - 宸﹀榻?*/
	.content-text {
		text-align: left !important;
		padding-left: 10px !important;
	}

	/* 签名单元格 */
	.signature-cell {
		height: 50px;
		padding: 10px !important;
		text-align: left;
	}

	/* 章节标题单元格 */
	.section-title-cell {
		text-align: center;
		font-weight: normal;
		padding: 10px !important;
		background-color: #fff;
		color: #000;
		font-size: 13px;
	}

	/* 图片标签单元格 */
	.images-label-cell {
		text-align: left;
		font-weight: normal;
		padding: 5px 10px !important;
		color: #000;
		font-size: 13px;
	}

	/* 图片区域单元格 */
	.images-section-cell {
		padding: 8px 10px !important;
		vertical-align: top;
		height: 150px;
	}

	/* 验收单图片网格 - 每行3张 */
	.image-grid-acceptance {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 10px;
		width: 100%;
		height: 100%;
	}


	.image-item-acceptance {
		width: 100%;
		height: 200px;
		overflow: hidden;
		border: none;
		background: #f5f5f5;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.acceptance-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}

	/* 底部单元格 */
	.footer-cell {
		text-align: center;
		padding: 10px !important;
		font-weight: normal;
		color: #000;
		font-size: 13px;
	}

	/* 维修监督表格样式 */
	.supervision-table td {
		border: 1px solid #999;
		padding: 10px 8px;
		font-size: 13px;
		vertical-align: middle;
		word-wrap: break-word;
		line-height: 1.5;
		color: #000;
	}

	.section-label-cell {
		text-align: center;
		font-weight: normal;
		padding: 10px !important;
		background-color: #fff;
		color: #000;
		font-size: 14px;
	}

	.images-section-cell-large {
		padding: 10px !important;
		vertical-align: top;
	}

	/* 鍥剧墖鍖呰９瀹瑰櫒 - 鍥哄畾楂樺害 */
	.images-wrapper {
		height: 280px;
		overflow: visible;
	}

	/* 维修监督图片网格 - 每行3张 */
	.image-grid-supervision {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 8px;
		width: 100%;
	}

	.image-item-supervision {
		width: 100%;
		height: 135px;
		overflow: hidden;
		border: none;
		background: #f5f5f5;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.image-item-supervision.large-image {
		height: 275px;
	}

	.supervision-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}

	.supervision-image.large-image {
		height: 275px;
	}

	/* 打印样式 */
	@media print {

		.preview-acceptance-dialog>>>.el-dialog__header,
		.preview-acceptance-dialog>>>.el-dialog__footer {
			display: none;
		}

		.preview-content {
			background-color: white;
		}

		.acceptance-form {
			width: 210mm;
			height: 297mm;
			padding: 10mm;
			margin: 0;
			box-shadow: none;
			box-sizing: border-box;
			page-break-after: always;
		}

		.acceptance-table {
			page-break-inside: avoid;
		}

		.acceptance-table td {
			page-break-inside: avoid;
		}
	}

	/* 响应式调整 */
	@media screen and (max-width: 900px) {
		.acceptance-form {
			width: 100%;
			min-height: auto;
			padding: 10mm;
		}
	}
</style>